module.exports = __webpack_public_path__ + "img/change_pin.62b93a64.svg";